export default {
    name: 'positive',
    validate(modelValue /* viewValue , record, options */) {
        return modelValue > 0;
    },
};
